import { render, staticRenderFns } from "./BatchProcessingContent.vue?vue&type=template&id=1a1cceb2"
import script from "./BatchProcessingContent.vue?vue&type=script&lang=js"
export * from "./BatchProcessingContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports